import * as React from "react";
const SvgBookmarked = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M12.4095 6.9939C10.9867 6.9939 9.88 8.15326 9.88 9.52341V32.7106C9.88 33.1849 10.1435 33.6592 10.5651 33.87C10.9867 34.0808 11.461 34.0281 11.8298 33.7646L19.9981 27.9678L28.1136 33.7646C28.4825 34.0281 29.0095 34.0808 29.431 33.87C29.8526 33.6592 30.1161 33.1849 30.1161 32.7106V9.52341C30.1161 8.15326 28.9568 6.9939 27.5866 6.9939H14.38H12.4095Z" }));
export default SvgBookmarked;
